import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var SpotComputersComponent = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 24,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'SpotComputers',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F5990D",
    d: "M9.14 18.67a1 1 0 0 1-1 1h-.61a1 1 0 0 0-1 1V21a1 1 0 0 0 1 1h8.94a1 1 0 0 0 1-1v-.33a1 1 0 0 0-1-1h-.61a1 1 0 0 1-1-1v-.4a1 1 0 0 0-1-1h-3.72a1 1 0 0 0-1 1v.4Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#BE7C00",
    d: "M14.86 18v.67a1 1 0 0 0 1 1H8.14a1 1 0 0 0 1-1V18a1 1 0 0 1 1-1h3.72a1 1 0 0 1 1 1Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F5990D",
    d: "M2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#FCC406",
    d: "M20.093 6.117a2 2 0 0 0-2.008-1.992l-12.21.04c-1.1-.001-2 .898-1.992 2.008l.033 8.24c0 .55.45 1 1 1.001l14.2-.048c.55 0 1-.45 1-1l-.023-8.25ZM19.25 17.32a.6.6 0 1 0 0-1.2.6.6 0 0 0 0 1.2Z"
  }));
};
SpotComputersComponent.displayName = 'SpotComputers';
export var SpotComputers = withProvisionalOverrideFromContext(SpotComputersComponent);
//# sourceMappingURL=index.js.map